import { Loader } from 'packages/eid-ui'
import { MenuItem, Typography, ListItemIcon, Paper } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useHistory } from 'react-router'
import { useQuery } from 'packages/core'
import { Icon } from 'packages/eid-icons'
import { useUiActionsByResource } from 'hooks'
import { useTranslation } from 'react-i18next'
import { handleRenderWorkflow } from 'utils'

const useMenuStyles = makeStyles((theme) => ({
    root: {
        fontSize: '14px',
        color: theme?.palette?.primary?.main,
        position: 'relative',
        minHeight: '40px',
        borderLeft: '2px solid transparent',
        whiteSpace: 'normal',
        '&:hover': {
            backgroundColor: `${theme?.palette?.primary?.light} !important`,
            borderLeft: `2px solid ${theme?.palette?.primary?.main}`,
            '& svg': {
                opacity: 1,
                filter: 'grayscale(0%) ',
                color: 'blue',
            },
        },
    },
    icon: {
        minWidth: '20px',
        color: '#aab0b4',
        '& svg': {
            height: '16px',
            width: '16px',
        },
    },
    noActionMessage: {
        minWidth: '40px',
        fontSize: '14px',
        padding: '10px',
    },
}))

const ActionsList = ({ workflows, resourceId, route }) => {
    const classes = useMenuStyles()
    const { t } = useTranslation()
    const query = useQuery()
    const history = useHistory()

    const handleClick = (name) => {
        handleRenderWorkflow(
            [`SelectedResourceGuid=${resourceId}`],
            name,
            history,
        )
    }

    return (
        <>
            {workflows && workflows.length > 0 ? (
                workflows.map((d, i) => (
                    <MenuItem
                        onClick={() => handleClick(d.requestWorkflowName)}
                        classes={classes}
                        key={i}
                    >
                        <ListItemIcon className={classes.icon}>
                            <Icon
                                name="Arrow"
                                direction="right"
                                color="#aab0b4"
                            />
                        </ListItemIcon>
                        {d.friendlyName}
                    </MenuItem>
                ))
            ) : (
                <Typography className={classes.noActionMessage}>
                    {t('NoActionFound')}
                </Typography>
            )}
        </>
    )
}

const WorkflowActions = ({ resource, route }) => {
    const { data, isInitialLoading } = useUiActionsByResource(resource.id)
    return (
        <>
            {isInitialLoading ? (
                <Loader />
            ) : (
                <Paper
                    style={{
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <ActionsList
                        workflows={data}
                        resourceId={resource.id}
                        route={route}
                    />
                </Paper>
            )}
        </>
    )
}

export default WorkflowActions
